import r2wc from "@r2wc/react-to-web-component";
import { PaymentSuccessContainer } from "../components/PaymentSuccessContainer";

const PaymentSuccessWebComponent = r2wc(PaymentSuccessContainer, {
  props: {
    rentalId: "string",
    apiKey: "string",
    fleetId: "string",
    stripePublishableKey: "string",
    theme: "string",
    onRetrySuccess: "function",
    onRetryError: "function",
    onBackToSearch: "function",
  },
  events: {
    onRetrySuccess: { bubbles: true, composed: true },
    onRetryError: { bubbles: true, composed: true },
    onBackToSearch: { bubbles: true, composed: true },
  },
});

if (!customElements.get("fm-payment")) {
  customElements.define("fm-payment", PaymentSuccessWebComponent);
}
